import { Avatar, Box, Button, Container, Stack, Typography } from "@mui/joy";
import { useFirestoreQuery } from "@react-query-firebase/firestore";
import { collection, orderBy, query, where } from "firebase/firestore";
import * as React from "react";
import { useSelector } from "react-redux";
import HeaderBackButton from "../components/HeaderBackButton";

import { db } from "../config/firebase";
import { History } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { NoTransaction } from "./notification";
import { HistoryItem } from "../components/HistoryItem";

export function NotificationData() {
  const userinfo = useSelector((state) => state.useInfos);
  const { id } = userinfo;

  React.useEffect(() => {}, [id]);

  const ref = query(
    collection(db, "users", id, "transactions"),
    orderBy("timestamp", "desc")
  );
  const querY = useFirestoreQuery(["activities"], ref);

  if (querY.isLoading) {
    return <Typography>Loading...</Typography>;
  }

  const snapshot = querY.data;

  let datalength = snapshot.docs.length;

  console.log(datalength);
  if (datalength > 0) {
    return snapshot.docs.map((docSnapshot, index) => {
      console.log(index);
      const data = docSnapshot.data();
      const { transaction_type, cointitle } = data;
      // console.log(docSnapshot.id);
      const isCredit = transaction_type === "Credit";

      const switchImage = (key) => {
        switch (key) {
          case "BTC":
            return "../images/coins/btc.png";
          case "ETH":
            return "../images/coins/eth.png";
          case "BNB":
            return "../images/coins/eth.png";
          case "TRX":
            return "../images/coins/tron.png";
          case "USDT":
            return "../images/coins/usdt.png";
          default:
            return "../images/coins/usdt.png";
        }
      };

      return (
        <HistoryItem
          key={index}
          data={data}
          id={docSnapshot.id}
          itemCode={isCredit ? "/call-received@2x.png" : "/call-made@2x.png"}
          imageCode={switchImage(cointitle)}
          frameBorder={isCredit ? "1px solid blue" : "1px solid #8a919e"}
        />
      );
    });
  }

  return <NoTransaction />;
}

export default function Activity() {
  const notificationLength = useSelector((state) => state.notificationsall);
  return (
    <Stack spacing={2} mt={1.3}>
      <NotificationData />
    </Stack>
  );
}
/*
export default function Activity() {
  const notificationLength = useSelector((state) => state.notificationsall);
  return (
    <Box mt={2}>{notificationLength > 0 ? <NotificationData /> : <NoTransaction />}</Box>
  );
}
*/
